import { INavConfig } from "./NavConfig";

export enum KrakenNavLinkType {
  HEADER = "header",
  DROPDOWN = "dropdown",
  ASIDE = "aside",
}

export interface IKrakenNavLink {
  linkConfig: INavConfig;
  badge?: boolean;
}

export interface IKrakenAuthNavProps {
  desktopVariant?: "slim" | "default";
}
